<template>
  <div class="page" v-cloak>
    <!-- 导航 -->
    <van-nav-bar :border="false" left-arrow fixed title="我的账户明细" class="user_balance_log_nav_bar" :z-index="9999" :style="'background: #4374FF; color:#FFFFFF;'" id="nav-bar" @click-left="onClickLeft"></van-nav-bar>
    <!-- 列表 -->
    <van-sticky :offset-top="46" :z-index="11">
      <div class="header-table">
        <p @click="showPicker = true">充值类型
          <van-icon name="arrow-down" />
        </p>
        <p @click="isShow = true">交易时间
          <van-icon name="arrow-down" />
        </p>
      </div>
    </van-sticky>

    <!-- 列表 --> 
    <div class="list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
        <text-row-balance v-for="(item, index) in list" :balance-data="item" :key="index"></text-row-balance>
      </van-list>
    </div>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar title="充值类型" :columns="poplist" @confirm="onConfirm" value-key="val" @cancel="showPicker = false" />
    </van-popup>

    <van-popup v-model="isShow" position="bottom">
      <van-datetime-picker v-model="start" type="year-month" title="交易时间" :min-date="minDate" :max-date="maxDate" :formatter="formatter" @cancel="cancelStart" @confirm="confirmStart" />
    </van-popup>

  </div>
</template>

<script type="text/babel">
import TextRowBalance from "@/components/text-row-balance/text-row-balance.vue";
export default {
  name: "BalanceLogList",
  components: { TextRowBalance },
  props: {},
  data() {
    return { 
      action: 0, //（pay:支出，recharge: 充值，refund: 退款）

      showPicker: false, // 类型选择
      poplist: [], //类型选择

      isShow: false,
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(),
      start: new Date(),
      startTime: undefined,

      list: [],
      pageNum: 1,
      pageSize: 10,
      loading: false,
      finished: false,
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.getcofig();
  },
  methods: { 
    getcofig() {
      let _this = this;
      let data = {
        // key: "RechargeType", // 充值类型
        key: "balanceLogType", //账户变动类型
        // limit: _this.pageSize,
      };
      _this.$post("/api/wash_config", data, data).then((res) => {
        console.log(res);

        if (res.data.code == 0) {
          console.log(res.data.data);

          var list = res.data.data;
          var array = [];
          array = Object.keys(list).map((val) => ({
            key: val,
            val: list[val],
          }));
          console.log(array);

          _this.poplist = array;
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    onConfirm(value, index) {
      console.log(value, index);
      this.showPicker = false;
      this.action = value.key;
      this.list = [];
      this.pageNum = 1;
      this.loading = true;
      this.finished = false;
      this.getList();
    },
    getList() {
      this.$toast.loading();
      let _this = this;
      let data = {
        type: _this.action, //
        date: _this.startTime, //
        // startTime: _this.startTime, //开始时间
        // endTime: _this.endTime, // 结束时间
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      _this.$post("/api/balance_list", data, data).then((res) => {
        // console.log(res.data);
        this.$toast.clear();
        _this.loading = false; // 加载状态结束

        if (res.data.code == 0) {
          // console.log(res.data.data);
          let lists = res.data.data;

          if (lists && lists.length > 0) {
            if (_this.pageNum == 1) {
              _this.list = [];
              _this.list = lists;
            } else {
              _this.list = _this.list.concat(lists);
            }
            _this.pageNum++;
            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            _this.finished = true; // 数据全部加载完成
          }
        } else {
          _this.$toast.fail(res.data.message);
          _this.finished = true;
        }
      });
    },

    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    confirmStart() {
      this.startTime = `${this.start.getFullYear()}-${this.doHandleMonth( this.start.getMonth() + 1 )}`;
      this.isShow = !this.isShow; 
      this.list = [];
      this.pageNum = 1;
      this.loading = true;
      this.finished = false;
      this.getList();
     
    },
    cancelStart() {
      this.startTime = undefined;
      this.isShow = !this.isShow; 
      this.list = [];
      this.pageNum = 1;
      this.loading = true;
      this.finished = false;
      this.getList();
    },  

    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    }, 
    //  当前日期30天前的日期
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    // 月 日 时间处理
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    // 当前日期
    filterTime() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
  },
};
</script>
<style lang="scss">
.user_balance_log_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
  .van-nav-bar__right {
    .van-nav-bar__text {
      color: #fff;
    }
  }
}
</style>
<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  padding: 46px 0;
  background-color: #f9f9f9;

  .list {
    padding: 0 0 30px;
  }
}
.header-table {
  height: 54px;
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #eeeeee;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
}
.pop-tips {
  text-align: left;
  padding: 0 10px;
  position: relative;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 27px;
  color: #454f63;
  letter-spacing: 1px;
  .in-text::after {
    content: "";
    position: absolute;
    width: 3px;
    height: 13px;
    left: 0;
    top: 8px;
    background: #4374ff;
    z-index: 1;
    border-radius: 0 10px 10px 0;
  }
}
.radio {
  text-align: center;
  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 25px;
  color: #666666;
  display: inline-block;
  padding: 5px 10px;
  background: #eeeeee;
  // border-radius: 5px;

  border-radius: 15px;
  margin: 5px 10px;
  border: 1px solid #eeeeee;
}
.radio-active {
  background: rgba(0, 168, 192, 0.1);
  border: 1px solid #2fa4ff;
  color: #4374ff;
}
.time-block {
  // position: relative;
  height: 50px;
  width: 100%;
  // border: 1px solid #eee;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 15px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 26px;
  color: #cccccc;
  .bo {
    border-bottom: 1px solid #4374ff !important;
    color: #4374ff;
  }
  .input-block {
    width: 125px;
    height: 50px;
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  .input-block-a {
    width: 125px;
    height: 50px;
    border-bottom: 1px solid #4374ff;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    color: #4374ff;
  }
}
.picker-time {
  margin-top: 20px;
  border: solid 1px #eee;
}
.btn-block {
  // position: absolute;
  // bottom: 10px;
  // left: 0;
  margin-top: 25px;
  width: 100%;
  height: 47px;
  padding: 0 15px;
  background-color: #ffffff;
  border-top: 1px solid #f9f9f9;

  box-shadow: 0px -5px 5px rgba(69, 79, 99, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  .btn-left {
    width: 50%;
    height: 40px;
    background: #2fa4ff;
    opacity: 1;
    border-top-left-radius: 20px;
    border-bottom-left-radius: 20px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-right {
    width: 50%;
    height: 40px;
    background: #4374ff;
    opacity: 1;

    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    line-height: 20px;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}
.btnC:active {
  background-color: rgba(255, 80, 0, 0.7) !important;
}
</style>
 